module.exports = __webpack_public_path__ + "img/组 4.c9478dd0.webp";